export const dateFormat = creationDate => {
  const formatDate = creationDate && creationDate?.toString()?.split('T')[0];
  const extractTime = creationDate && creationDate?.toString()?.split('T')[1]?.split(':');
  const formatTime = extractTime[0] + ':' + extractTime[1];

  return formatDate + ' ' + formatTime;
};
